import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { SingleMultipleChoiceAnswerValue } from '../answer-value';
import { Answer } from './answer';
import { SubmissionScore } from '../submission-score';
export var MultipleChoiceAnswer = /*#__PURE__*/function (_Answer) {
  _inherits(MultipleChoiceAnswer, _Answer);

  var _super = _createSuper(MultipleChoiceAnswer);

  function MultipleChoiceAnswer() {
    _classCallCheck(this, MultipleChoiceAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(MultipleChoiceAnswer, [{
    key: "values",
    get: function get() {
      return this.props.values;
    }
  }, {
    key: "updateValues",
    value: function updateValues(newValues) {
      this.props.values = newValues;
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return !this.values || this.values && this.values.length === 0;
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(question) {
      var isAnswerValuesLengthEqualWithCorrectAnswerLength = this.values.length === question.correctAnswers.length;

      if (!isAnswerValuesLengthEqualWithCorrectAnswerLength) {
        return false;
      }

      var isAllCorrectAnswers = this.values.every(function (a) {
        var hasContainedAnswer = question.correctAnswers.some(function (c) {
          return c.answerId === a.answerId;
        });
        return hasContainedAnswer;
      });
      return isAllCorrectAnswers;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var dataOrError = this.createBaseProps(props);

      if (dataOrError.isFailure) {
        return Result.fail(dataOrError.error);
      }

      var baseProps = dataOrError.getValue();
      var collection = [{
        argument: props.values,
        argumentName: 'Values'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      props = _objectSpread(_objectSpread({}, baseProps), props);
      return Result.ok(new MultipleChoiceAnswer(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var basePropsOrError = this.createBaseProps(data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var values = data.values;
        var answerValueProps = values.map(function (value) {
          return SingleMultipleChoiceAnswerValue.create({
            answerId: value.answerId
          }).getValue();
        });
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          values: answerValueProps,
          score: data !== null && data !== void 0 && data.score || data.score === 0 ? SubmissionScore.create(data.score).getValue() : null
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MultipleChoiceAnswer;
}(Answer);